import { defineStore, acceptHMRUpdate } from 'pinia';
import Group from '@/models/Group';

const store = defineStore('users-groups', {
  state: () => ({
    companyGroups: [],
    loaded: false,
  }),

  getters: {
    getCompanyGroups(state) { // return false while not loaded
      return state.loaded && state.companyGroups.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    groupsById(state) {
      return state.companyGroups.reduce((acc, item) => { acc[item.id] = item; return acc; }, {});
    },
    getGroupById() {
      return groupId => this.groupsById[groupId];
    },
    getUserGroups(state) {
      return user => state.companyGroups.filter(group => group.users.find(groupUser => groupUser.id == user.id));
    },
  },

  actions: {
    load() {
      return window.apiSrv.call('groups', 'index').then((response) => {
        this.companyGroups.splice(0, this.companyGroups.length);
        (response?.data?.groups || []).forEach((groupData) => {
          this.companyGroups.push(new Group(groupData));
        });
        this.loaded = true;
        return this.companyGroups;
      });
    },
    createGroup(title) {
      if (! title) return Promise.reject('title is required');
      return window.apiSrv.call('groups', 'store', { title }).then((response) => {
        const group = new Group(response?.data?.group);
        this.companyGroups.push(group);
        return group;
      });
    },
    updateGroup({ groupId, title }) {
      return window.apiSrv.call('groups', 'update', { id: groupId, title }).then(() => {
        const index = this.companyGroups.findIndex(item => item.id == groupId);
        if (index > -1) this.companyGroups[index].title = title;
      });
    },
    deleteGroup(groupId) {
      return window.apiSrv.call('groups', 'destroy', { id: groupId }).then(() => {
        const index = this.companyGroups.findIndex(item => item.id == groupId);
        if (index > -1) this.companyGroups.splice(index, 1);
      });
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
